import { forwardRef } from 'react';

import Popup from '../Popup';
import DateTimePickerRenderer from '../../date-time-picker/date-time-picker-renderer';


/** Popup version of date pickers. */
const PopupDateTimePicker = forwardRef(({
    // Popup props
    width,
    open,
    maxHeight,
    arrowProps,
    style = {},
    placement,
    zIndex,
    popupZIndex,

    type = 'datetime-range',

    // Rest get passed to DateTimeRangePicker
    ...props
}, ref) => {


    return (
        <Popup
            width={width ?? 347}
            open={open}
            usePortal
            maxHeight={maxHeight}
            arrowProps={arrowProps}
            zIndex={zIndex ?? popupZIndex}
            style={{
                padding: 15,
                ...style
            }}
            ref={ref}
            placement={placement}
        >
            {
                // Unmount component when popup closed to reset the currently displayed month
                // Maybe not best solution for this
                open && (
                    <DateTimePickerRenderer
                        type={type}
                        {...props}
                    />
                )
            }
        </Popup>
    );
});

export default PopupDateTimePicker;
